import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutionuna() {
  return (
    <section className="solution_una p-100 text_una">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/una/solution_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={668}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              <strong>Tekrevol's Solution</strong>
              <br /> An All-Rounder Solution To Help UNA Graduates Kick-Start
              Their Careers
            </h2>
            <p>
              Tekrevol understood what the client expected from the UNA Job
              Portal mobile app, and the first step was to sketch out a plan for
              the project. We set a long-term goal to help UNA graduates find
              their dream jobs which required a mobile app with exceptional
              functionalities. We ensured the mobile app was smooth and easy for
              anyone to navigate through to find a job. The final project had
              the best combination of features and user interface, making it
              highly functional and serve its primary purpose – to help job
              seekers
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionuna;
